/**
 * Created by Ko-Hsin on 16/05/2018.
 */

import { Component,ViewEncapsulation } from '@angular/core';
import {AuthService} from "../../../core/auth.service";
import {StateService} from "../../../core/state.service";
import {AngularFirestore} from "angularfire2/firestore/firestore";

@Component({
    selector: 'email-settings',
    template: `
<div class="email-settings">
    <alert-panel [(message)]="alert_message"></alert-panel>
    <div class="flex flex-col smaller_text">
        <div class="standalone_title">Email Settings</div>
        <mat-checkbox color="primary" [(ngModel)]="email_monthly_receipts" (change)="interaction()">Monthly receipt</mat-checkbox>
        <mat-checkbox color="primary" [(ngModel)]="email_postevent_reports" (change)="interaction()">Post-event reports</mat-checkbox>
        <mat-checkbox color="primary" [(ngModel)]="email_promo_checkit" (change)="interaction()">Promotional material about new features and offers in Checkit</mat-checkbox>
        <mat-checkbox color="primary" [(ngModel)]="email_promo_joi" (change)="interaction()">Promotional material about new features and offers in other Joi products</mat-checkbox>
        <div>
            <button [disabled]="!unsaved_settings" (click)="saveEmailSettings()">Save Email Settings</button>
        </div>
        
    </div>
</div>
    `,
    styles: [`
        .smaller_text { font-size: 14px; line-height: 24px;}
        .email-settings button {  margin: 20px 0 0;}
        .email-settings button:disabled { cursor:default; opacity:.5; }
        .email-settings button:disabled:hover { background-color: #fff; }
        .email-settings .mat-checkbox-layout { white-space: normal; }
        .email-settings .mat-checkbox-inner-container { margin-top: 2px; }
    `],
    encapsulation: ViewEncapsulation.None
})
export class EmailSettingsComponent {

    email_monthly_receipts;
    email_postevent_reports;
    email_promo_checkit;
    email_promo_joi;
    unsaved_settings;
    init_settings;
    alert_message;

    constructor(public state:StateService, public afs:AngularFirestore){
        if(!this.state.settings) this.state.settings = {};
        this.init_settings = this.state.settings;
        this.email_monthly_receipts =  !!this.state.settings.email_monthly_receipts;
        this.email_postevent_reports = !!this.state.settings.email_postevent_reports;
        this.email_promo_checkit = !!this.state.settings.email_promo_checkit;
        this.email_promo_joi = !!this.state.settings.email_promo_joi;
        this.state.$requests.subscribe(request=>{
            if(request.request == 'subscriptionStatusSet'){
                if(!this.state.settings) this.state.settings = {};
                this.init_settings = this.state.settings;
                this.email_monthly_receipts =  !!this.state.settings.email_monthly_receipts;
                this.email_postevent_reports = !!this.state.settings.email_postevent_reports;
                this.email_promo_checkit = !!this.state.settings.email_promo_checkit;
                this.email_promo_joi = !!this.state.settings.email_promo_joi;
            }
        })
    }

    interaction(){
        this.unsaved_settings = false;
        if(this.init_settings){
            if(this.email_monthly_receipts  != this.init_settings.email_monthly_receipts)   this.unsaved_settings = true;
            if(this.email_postevent_reports != this.init_settings.email_postevent_reports)  this.unsaved_settings = true;
            if(this.email_promo_checkit     != this.init_settings.email_promo_checkit)      this.unsaved_settings = true;
            if(this.email_promo_joi         != this.init_settings.email_promo_joi)          this.unsaved_settings = true;
        }else{
            this.unsaved_settings = true;
        }
    }

    saveEmailSettings(){
        if(!this.unsaved_settings) return;
        this.afs.doc<any>(`accounts/${this.state.accounts['currentId']}`).set({settings:{
            email_monthly_receipts:this.email_monthly_receipts,
            email_postevent_reports:this.email_postevent_reports,
            email_promo_checkit:this.email_promo_checkit,
            email_promo_joi:this.email_promo_joi
        }},{merge:true}).then(_=>{
            this.unsaved_settings = false;
            this.alert_message = 'Your email settings have been updated'
        })
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/account/components/email-settings.ts